import { getNotificationsApiHeaders } from '@module/mdrt-org/shared/utils/helpers/get-headers';

import { fetchWithErrorHandling } from '../http-services/fetch-with-error-handling';

export type UserNotification = {
  body: string;
  createdAtUtc: string;
  id: string;
  isRead: boolean;
  lastModifiedAtUtc: string;
  publishedAtUserTimeZone: string;
  publishedAtUtc: string;
  title: string;
  updatedAtUtc: Nullable<string>;
  url: Nullable<string>;
};

export type UserNotificationsDTO = {
  notifications: UserNotification[];
  totalCount: number;
  unreadCount: number;
};

export const getUserNotifications = async ({
  accessToken,
  itemsCount,
  personId,
}: {
  accessToken: string | undefined;
  itemsCount: number;
  personId: number | undefined;
}) => {
  if (!(accessToken && personId)) {
    throw new Error('Access token or person ID is not available');
  }

  return await fetchWithErrorHandling<UserNotificationsDTO>(
    `${window.PUBLIC_ENV.apiBaseUrl}/${
      window.PUBLIC_ENV.notificationsApiRoute ?? 'notifications-api'
    }/Notifications/Users/${personId}?itemsCount=${itemsCount}`,
    {
      cache: 'no-store',
      headers: {
        ...getNotificationsApiHeaders(accessToken),
      },
    }
  );
};
